module["exports"] = [
  "gmail.com",
  "yahoo.co.in",
  "hotmail.com"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_IND/internet/free_email.js
 ** module id = 430
 ** module chunks = 0
 **/